@if (isVisible()) {
  <aside class="override-indicator" role="status" aria-label="App settings overridden for this session">
    <button
      type="button"
      class="override-indicator__summary"
      [attr.aria-expanded]="isExpanded()"
      aria-controls="override-indicator-detail"
      (click)="toggle()"
    >
      <span class="override-indicator__dot" aria-hidden="true"></span>
      <span class="override-indicator__label">
        {{ overrides().length }} setting{{ overrides().length === 1 ? '' : 's' }} overridden
      </span>
      <!-- The canonical chevron paths (libs/shared/ui-icons chevron-down / chevron-right), inlined the
           way the booking wizard's header does, so this keeps `imports: []` and doesn't depend on the
           svg-icon registry being populated in the host. Deliberately not the U+25BE / U+25B8 geometric
           glyphs: Eina has no cmap entry for either, so they render in a fallback font. -->
      <svg
        class="override-indicator__chevron"
        viewBox="0 0 24 24"
        width="14"
        height="14"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        @if (isExpanded()) {
          <path d="m6 9 6 6 6-6" />
        } @else {
          <path d="m9 18 6-6-6-6" />
        }
      </svg>
    </button>

    @if (isExpanded()) {
      <div id="override-indicator-detail" class="override-indicator__detail">
        <dl class="override-indicator__list">
          @for (override of overrides(); track override.name) {
            <div class="override-indicator__row">
              <dt class="override-indicator__name">{{ override.name }}</dt>
              <dd class="override-indicator__value">{{ override.value }}</dd>
            </div>
          }
        </dl>

        <button type="button" class="override-indicator__clear" (click)="clear()">
          Clear and reload
        </button>
        <p class="override-indicator__hint">or add ?{{ clearParam }}=1 to any URL</p>
      </div>
    }
  </aside>
}
